import { combineReducers } from 'redux'
import add from './add'
import invoices from './invoices'
import selected from './selected'
import postReport from './postReport'
import notInvoiced from './notInvoiced'
import selector from './selector'
import purchasing from './purchasing'
import receivedNotInvoiced from './receivedNotInvoiced'

export default combineReducers({
  add,
  invoices,
  selected,
  postReport,
  notInvoiced,
  selector,
  purchasing,
  receivedNotInvoiced,
})
